<template>
  <a class="cta-round" :class="{orange: theme == 'orange', blue: theme == 'blue'}">
      {{text}}
  </a>
</template>

<script>
export default {
  name: 'v-button-round',
  props: ['text', 'theme']
}
</script>

<style lang="scss">
  .cta-round {
      padding: rem(15px) rem(50px);
      font-size: rem(14px);
      line-height: rem(18px);
      border-radius: 30px;
      color: #fff;
      width:auto;
      cursor: pointer;
      border: none;
      margin-top: 1.2rem;
      text-align: center;
      -webkit-print-color-adjust: exact;

      &.u-bg--blue {
      	background-color:purple;
      }

    @include mq($until: MD) {
      display: flex;
    }
  }

</style>
